















import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
	components: {}
})
export default class RadioButton extends Vue {
	@Model('input', { type: String, default: null })
	protected readonly checkedValue!: string | null;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop({ type: String, default: null })
	protected readonly id!: string | null;

	@Prop({ type: String, default: null })
	protected readonly value!: string | null;

	@Prop({ type: String, default: null })
	protected readonly text!: string | null;

	@Prop({ type: Boolean, default: false })
	protected readonly required!: boolean;
}
